import { Button } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import { getPxAsRem } from 'shared/utils'
import { EDUCATION_SECTIONS } from '.'
import { EditButtonContainer } from '../styled'

export interface EditButtonContainerProps {
    onCancel?: () => void
    setEdit: Dispatch<SetStateAction<EDUCATION_SECTIONS | null>>
    setUnsavedChangesExist: Dispatch<SetStateAction<boolean>>
    unsavedChangesExist: boolean
    hasValidationErrors?: boolean
    sectionType: EDUCATION_SECTIONS
    activeEditingSection: EDUCATION_SECTIONS | null
}

const EditButtonsContainer: React.FC<EditButtonContainerProps> = ({
    setEdit,
    setUnsavedChangesExist,
    unsavedChangesExist,
    hasValidationErrors,
    onCancel,
    sectionType,
    activeEditingSection,
}) => {
    return (
        activeEditingSection === sectionType && (
            <EditButtonContainer sx={{ marginTop: getPxAsRem(24) }}>
                <Button
                    variant="outlined"
                    type="reset"
                    onClick={() => {
                        onCancel?.()
                        setEdit(null)
                        setUnsavedChangesExist(false)
                    }}
                >
                    Cancel
                </Button>
                <Button
                    type="submit"
                    disabled={!unsavedChangesExist || hasValidationErrors}
                >
                    Save and Update
                </Button>
            </EditButtonContainer>
        )
    )
}

export default EditButtonsContainer
